<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            Rakes
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col v-for="(value, name) in device_status">
            <v-chip :color="name" dark>{{ name }} : {{ value }}</v-chip>
          </v-col>
          <!-- <v-col>
          <v-btn color="primary" dark class="mb-2" @click.stop="addRake">Add Rake</v-btn>
        </v-col> -->
          <v-col>
            <v-dialog v-model="dialog1" max-width="850px">
              <!-- <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Add Employee</v-btn>
              </template> -->
              <v-card>
                <v-card-text>
                  <v-form v-model="valid">
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.name"
                            label="Rake No"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.contact"
                            label="No of Cars etc."
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.uniqueid"
                            label="Device ID"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.phone"
                            label="Phone"
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12">
                        <v-textarea v-model="editedItem.contact" label="Beacons"></v-textarea>
                      </v-col> -->
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="closeRakeDialog"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="saveRake"
                    :disabled="!valid"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card-title>
      <v-dialog v-model="dialog" max-width="850px">
        <v-card>
          <v-card-text>
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="400px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormatted"
                          label="Train Date"
                          hint="DD/MM/YYYY format"
                          persistent-hint
                          required
                          :rules="dateRules"
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="train_date"
                        no-title
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <template>
                    <v-data-table
                      :headers="selectableTrainsHeader"
                      :items="selectableTrains"
                      :search="search"
                      :footer-props="{
                        'items-per-page-options': [10, 20, 30, 40, 50],
                      }"
                      :items-per-page="40"
                      sort-by="dep"
                      class="elevation-1"
                      @click:row="saveTrainAdd($event)"
                    >
                    </v-data-table>
                  </template>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="cancelTrainAdd"
              >Cancel</v-btn
            >
            <v-btn
              color="blue darken-1"
              text
              @click="saveTrainAdd"
              :disabled="!valid"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :headers="headers"
        :items="devices"
        :search="search"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50, 150],
        }"
        :items-per-page="130"
        @click:row="onRowClick($event)"
        class="elevation-1"
        :mobile-breakpoint="100"
      >
        <!-- <template v-slot:item.id="{ item }">
        {{devices.map(function(x) {
      return x.id;
      }).indexOf(item.id)+1}}
      </template> -->
        <template v-slot:item.lastupdate="{ item }">
          <v-chip :color="getColour(item.lastupdate)" dark>{{
            getTimeFromNow(item.lastupdate)
          }}</v-chip>
        </template>
        <template v-slot:item.last_train_no="{ item }">
          <span :color="getColour(item.last_train_date)"
            >{{ getFormattedDate(item.last_train_date) }}
            {{ item.last_train_no }} {{ item.org }}
            {{ getFormattedTime(item.dep) }} {{ item.dest }}
            {{ getFormattedTime(item.arr) }}</span
          >
        </template>
        <template v-slot:item.attributes="{ item }">
          <span v-if="item.attributes">
            P: {{ Math.round(JSON.parse(item.attributes).power, 2) }}v B:
            {{ Math.round(JSON.parse(item.attributes).battery, 2) }}v KM:
            {{
              Math.round(JSON.parse(item.attributes).totalDistance / 1000, 0)
            }}
          </span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            text
            icon
            color="blue"
            dark
            @click.native.stop="editRake(item)"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            text
            icon
            color="purple"
            dark
            @click.native.stop="openTrainAdd(item)"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
          <!-- <v-btn text icon color="blue" dark @click.native.stop="deleteItem(item)">
      <v-icon dark>mdi-delete</v-icon>
    </v-btn> -->
          <v-btn
            text
            icon
            color="green"
            dark
            @click.native.stop="onRowClick(item)"
          >
            <v-icon dark>mdi-information</v-icon>
          </v-btn>
          <v-btn
            text
            icon
            color="blue"
            dark
            @click.native.stop="showSpeedMap(item)"
          >
            <v-icon dark>mdi-map</v-icon>
          </v-btn>
          <v-btn
            text
            icon
            color="blue"
            dark
            @click.native.stop="showRakeDtls(item)"
          >
            <v-icon dark>mdi-pencil-box-multiple</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState, mapGetter, mapActions } from "vuex";

export default {
  name: "devices",
  data() {
    return {
      search: "",
      errors: [],
      valid: false,
      dateRules: [(v) => !!v || "Date is required"],
      dialog: false,
      dialog1: false,
      headers: [
        {
          text: "Srl",
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: "Rake No",
          align: "left",
          sortable: true,
          value: "name",
          width: "10%",
        },
        {
          text: "No of Cars etc.",
          value: "contact",
        },
        {
          text: "Device ID",
          value: "uniqueid",
        },
        {
          text: "Mobile No",
          value: "phone",
        },
        {
          text: "Last Update",
          value: "lastupdate",
        },
        {
          text: "Attributes",
          value: "attributes",
        },
        {
          text: "Actions",
          value: "action",
          sortable: false,
        },
      ],
      train_date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      selectableTrains: [],

      selectableTrainsHeader: [
        {
          text: "Outgoing Train",
          align: "left",
          sortable: true,
          value: "train_no",
        },
        {
          text: "ORG",
          value: "org",
        },
        {
          text: "Sch Dep.",
          value: "dep",
        },
        {
          text: "DEST",
          value: "dest",
        },
        {
          text: "Sch Arr",
          value: "arr",
        },
      ],
      device: {},
      device_loading: false,
      devices: [],
      device_status: {
        green: 0,
        orange: 0,
        red: 0,
        total: 0,
      },
      snack: false,
      snackColor: "",
      snackText: "",
      menu1: false,
      menu2: false,
      editTrain: false,
      editedIndex: -1,
      editedItem: {
        name: "",
        uniqueidt: "",
        phone: "",
        contact: "",
        beacons: "",
      },
      defaultItem: {
        name: "",
        uniqueidt: "",
        phone: "",
        contact: "",
        beacons: "",
      },
    };
  },
  created() {
    this.getDevices();
  },
  computed: {
    ...mapState([
      "curDeviceId",
      "curDeviceName",
      "curTrainNo",
      "curTrainDate",
      "curOrg",
      "curArr",
      "actArr",
      "curDest",
      "curDep",
    ]),
    computedDateFormatted() {
      return this.formatDate(this.train_date);
    },
  },
  watch: {
    train_date(val) {
      this.dateFormatted = this.formatDate(this.train_date);
    },
  },
  methods: {
    ...mapActions([
      "updateCurDeviceId",
      "updateCurDeviceName",
      "updateCurTrainNo",
      "updateCurTrainDate",
      "updateCurOrg",
      "updateCurArr",
      "updateActArr",
      "updateCurDest",
      "updateCurDep",
    ]),

    getDevices() {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      axios
        .get(`${process.env.VUE_APP_API_URL}/device`)
        .then((response) => {
          //          console.log(response.data)
          this.devices = [];
          _.assign(this.device_status, {
            green: 0,
            orange: 0,
            red: 0,
            total: 0,
          });
          this.devices = response.data;
          _.forEach(response.data, (device) => {
            this.device_status[this.getColour(device.lastupdate)]++;
            this.device_status["total"]++;
          });
        })
        .catch((e) => {
          if (e.status === 401) {
            console.log(e);
            this.$router.push({
              name: "Login",
            });
          }
        });
    },
    showSpeedMap(item) {
      this.updateCurDeviceId(item.id);
      this.updateCurDeviceName(item.name);
      this.updateCurDep(
        moment()
          .subtract(2, "h")
          .format("YYYY-MM-DD HH:mm:ss")
      );
      this.updateCurArr(moment().format("YYYY-MM-DD HH:mm:ss"));
      this.updateActArr(moment().format("YYYY-MM-DD HH:mm:ss"));
      this.$router.push({ name: "SpeedOnMap" });
    },
    showRakeDtls(item) {
      console.log(item);
      this.$router.push({
        path: "/rake_dtls",
        query: {
          deviceid: item.id,
        },
      });
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("DD/MM/YYYY");
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date, ["DD/MM/YYYY"]).format("YYYY-MM-DD");
    },
    editTrains(item) {
      this.editTrain = true;
      this.openTrainAdd(item);
    },
    openTrainAdd(item) {
      this.selectedDnTrain = item;
      this.selectedDnTrainIndex = this.devices.indexOf(item);
      this.train_date = this.getFormattedDateInISOFormat(item.last_train_date);
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      var para = {
        dest: this.editTrain ? item.org : item.dest,
        arr: this.getFormattedTime(item.arr),
      };

      axios
        .get(`${process.env.VUE_APP_API_URL}/train/tr/uptrains`, {
          params: para,
        })
        .then((response) => {
          this.selectableTrains = _.filter(response.data, (o) => {
            if (
              _.indexOf(
                [
                  "BNJ",
                  "KNJ",
                  "STB",
                  "LGL",
                  "RHA",
                  "GEDE",
                  "HNB",
                  "KLYM",
                  "KYI",
                  "NH",
                  "BP",
                  "GBG",
                  "HB",
                  "DTK",
                  "MMG",
                  "DDJ",
                  "DKAE",
                  "BRPA",
                  "BWN",
                  "KWAE",
                  "SDAH",
                  "MJT",
                ],
                item.org
              ) > -1
            ) {
              return (
                _.indexOf(
                  [
                    "BNJ",
                    "KNJ",
                    "STB",
                    "LGL",
                    "RHA",
                    "GEDE",
                    "HNB",
                    "KLYM",
                    "KYI",
                    "NH",
                    "BP",
                    "GBG",
                    "HB",
                    "DTK",
                    "MMG",
                    "DDJ",
                    "DKAE",
                    "BRPA",
                    "BWN",
                    "KWAE",
                    "SDAH",
                    "MJT",
                  ],
                  o.dest
                ) > -1
              );
            }
            if (
              _.indexOf(
                [
                  "DH",
                  "NAM",
                  "LKPR",
                  "CG",
                  "BGB",
                  "BRP",
                  "SPR",
                  "BLN",
                  "MJT",
                  "SDAH",
                ],
                item.org
              ) > -1
            ) {
              return (
                _.indexOf(
                  [
                    "DH",
                    "NAM",
                    "LKPR",
                    "CG",
                    "BGB",
                    "BRP",
                    "SPR",
                    "BLN",
                    "MJT",
                    "SDAH",
                  ],
                  o.dest
                ) > -1
              );
            }
          });
          this.dialog = true;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    cancelTrainAdd() {
      this.dialog = false;
    },
    saveTrainAdd(item) {
      var dep = moment(this.train_date).format("YYYY-MM-DD") + " " + item.dep;
      var arr = moment(this.train_date).format("YYYY-MM-DD") + " " + item.arr;
      if (moment(dep) > moment(arr)) {
        arr = moment(arr)
          .add(1, "days")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      var train_device_map = {
        train_date: moment(this.train_date).format("YYYY-MM-DD"),
        train_no: item.train_no,
        device_id: this.selectedDnTrain.id,
        device_name: this.selectedDnTrain.name,
        unique_device_id: this.selectedDnTrain.uniqueid,
        org: item.org,
        dep: dep,
        dest: item.dest,
        arr: arr,
      };
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      axios
        .post(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
        .then((response) => {
          //        console.log(item)
          this.devices[this.selectedDnTrainIndex].last_train_id = item.id;
          this.devices[
            this.selectedDnTrainIndex
          ].last_train_date = this.train_date;
          this.devices[this.selectedDnTrainIndex].last_train_no = item.train_no;
          this.devices[this.selectedDnTrainIndex].dest = item.dest;
          this.devices[this.selectedDnTrainIndex].org = item.org;
          this.devices[this.selectedDnTrainIndex].dep = dep;
          this.devices[this.selectedDnTrainIndex].arr = arr;
          this.updatePFno(
            this.selectedDnTrain.device_train_map_id,
            this.selectedDnTrain.pf,
            item.train_no,
            response.data.results.insertId,
            item.dest
          );
        })
        .catch((e) => {
          this.snackColor = "error";
          this.snackText = e.data.msg;
          this.snack = true;
          console.log(e);
        });
      this.dialog = false;
    },
    updatePFno(
      device_train_map_id,
      pf,
      next_train_no,
      next_train_no_id,
      next_train_description
    ) {
      var next_train_no_para = {
        id: device_train_map_id,
        pf: pf,
        next_train_no: next_train_no,
        next_train_no_id: next_train_no_id,
        next_train_description: next_train_description,
      };
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/train/updatenexttrainno/`,
          next_train_no_para
        )
        .then((res) => {
          this.snackColor = "success";
          this.snackText = res.data.msg;
          this.snack = true;
          //        console.log(res)
        })
        .catch((err) => {
          this.snackColor = "error";
          this.snackText = e.data.msg;
          this.snack = true;
          console.log(err);
        });
    },
    // deleteItem (item) {
    //   var train_device_map = {
    //       id: item.last_train_id,
    //     }
    //   if (confirm('Are you sure you want to delete this item?')) {
    //     axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    //     axios.delete(`${process.env.VUE_APP_API_URL}/train/`, {params: train_device_map})
    //     .then(response => {
    //       //alert("Registered successfully")
    //         this.getDevices()
    //       })
    //     .catch(e => {
    //       console.log(e)
    //       this.errors.push(e)
    //     })
    //
    //   }
    // },
    onRowClick($event) {
      this.updateCurDeviceId($event.id);
      this.updateCurDeviceName($event.name);
      this.$router.push({
        name: "Trains",
      });
    },
    clear() {},
    open() {},
    addRake() {
      this.dialog1 = true;
    },
    closeRakeDialog() {
      this.dialog1 = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveRake() {
      var device = {
        uniqueid: this.editedItem.uniqueid,
        name: this.editedItem.name,
        model: this.editedItem.model,
        phone: this.editedItem.phone,
        contact: this.editedItem.contact,
      };
      if (this.editedIndex > -1) {
        device.id = this.editedItem.id;
        axios.defaults.headers.common["Authorization"] = localStorage.getItem(
          "jwtToken"
        );
        axios
          .put(`${process.env.VUE_APP_API_URL}/device`, device)
          .then((response) => {
            this.initialize();
          })
          .catch((e) => {
            console.log(e);
            this.errors.push(e);
          });
      } else {
        //console.log(train_device_map)
        axios.defaults.headers.common["Authorization"] = localStorage.getItem(
          "jwtToken"
        );
        axios
          .post(`${process.env.VUE_APP_API_URL}/device`, device)
          .then((response) => {
            this.initialize();
            //alert("Registered successfully")
          })
          .catch((e) => {
            console.log(e);
            this.errors.push(e);
          });
      }
      this.closeRakeDialog();
    },
    editRake(item) {
      this.editedIndex = this.devices.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log(this.editedItem);
      this.dialog1 = true;
    },
    // getFormattedTime(t) {
    //   if (t) {
    //     var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
    //     var testDateUtc = moment.utc(lt);
    //     var localDate = moment(testDateUtc).local();
    //     return localDate.format("DD/MM/YYYY HH:mm:ss")
    //   } else {
    //     return 'Off Line'
    //   }
    // },
    getFormattedTime(t) {
      if (t && t !== "--") {
        //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        //  var testDateUtc = moment.utc(lt);
        // var localDate = moment(testDateUtc).local();
        //  return moment(localDate).format("HH:mm:ss")
        return moment.utc(t).format("HH:mm:ss");
      }
    },
    getFormattedDateInISOFormat(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return localDate.format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    getColour(t) {
      if (t) {
        var lt = moment(t)
          .tz("UTC")
          .format("YYYY-MM-DD HH:mm:ss");
        //  var testDateUtc = moment.utc(lt);
        var localDate = moment(lt);
        var duration = moment().diff(localDate, "minutes");
        return duration > 5 ? "orange" : "green";
      } else {
        return "red";
      }
    },
    // getTimeFromNow(t) {
    //   if (t) {
    //     console.log(t)
    //     // var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
    //     // var testDateUtc = moment.utc(lt);
    //     // var localDate = moment(t).local();
    //     return moment(t).tz('Asia/Kolkata').fromNow()
    //   } else {
    //     return 'Off Line'
    //   }
    // },
    getTimeFromNow(t) {
      if (t) {
        var lt = moment(t)
          .tz("UTC")
          .format("YYYY-MM-DD HH:mm:ss");
        // var testDateUtc = moment.utc(lt);
        // var localDate = moment(testDateUtc).local();
        return moment(lt).fromNow();
      } else {
        return "Off Line";
      }
    },
    getFormattedDate(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return moment(t).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    formatTime(t) {
      if (t) {
        return moment(t).format("HH:mm:ss");
      } else {
        return "";
      }
    },
  },
};
</script>
